import { render } from "./CampaignView.vue?vue&type=template&id=25c54c39&ts=true"
import script from "./CampaignView.vue?vue&type=script&lang=ts"
export * from "./CampaignView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__